import request from "@/utils/request";

export const url = {
  GroupOrder_OrderList: "/api/GroupOrder/GetGroupOrderPageList", //获取订单分页(集团版)
  GroupOrder_BookingList: "/api/GroupOrder/GetGroupBookingPageList", //集团预定分页(集团版)
  GroupOrder_CreateOrder: "/api/GroupOrder/CreateOrder", //生成预订单(集团版)
  GroupOrder_UpdateOrder: "/api/GroupOrder/UpdateOrder", //修改订单(集团版)
  GroupOrder_CancelOrder: "/api/GroupOrder/Cancel", //取消订单(集团版)整单
  GroupOrder_RecoverOrder: "/api/GroupOrder/Recover", //恢复订单(集团版)整单
  GroupOrder_CancelDetail: "/api/GroupOrder/CancelDetail", //取消订单(集团版) 订单明细
  GroupOrder_RecoverDetail: "/api/GroupOrder/RecoverDetail", //恢复订单(集团版) 订单明细
  GroupOrder_Detail: "/api/GroupOrder/GetGroupOrderDetail", //获取订单详情(集团版)
  GroupOrder_RoomPrice: "/api/GroupOrder/GetRoomPrice", //询房价(集团版)
  GroupOrder_Room_GetDefaultTime: "/api/GroupOrder/GetDefaultItem", //获取默认预抵，预离时间(集团版) 仅传CompanyId即可，Id为预留的价类Id
  GroupOrder_Log: "/api/GroupOrder/GetOrderLogPageList", //查询订单日志
};
function sendRequest(apiUrl, params, type) {
  return request({
    url: apiUrl,
    method: type,
    data: params,
  });
}

export default class groupOrderApi {
  /**
   * 获取订单分页(集团版)
   */
  static GetGroupOrderPageList(params, type = "post") {
    return sendRequest(url.GroupOrder_OrderList, params, type);
  }
  /**
   * 获取订单详情(集团版)
   */
  static GetGroupOrderDetail(params, type = "post") {
    return sendRequest(url.GroupOrder_Detail, params, type);
  }
  /**
   * 查询订单日志
   */
  static GetOrderLogPageList(params, type = "post") {
    return sendRequest(url.GroupOrder_Log, params, type);
  }
  /**
   * 获取集团门店数据
   * @description: 获取房态
   * @param {Object} data
   * @return:
   */
  static GetGroupBookingList(params, type = "post") {
    return sendRequest(url.GroupOrder_BookingList, params, type);
  }
  /**
   * 获取集团默认参数
   * @description: 获取房态
   * @param {Object} data
   * @return:
   */
  static GetGroupDefault(params, type = "post") {
    return sendRequest(url.GroupOrder_Room_GetDefaultTime, params, type);
  }
  /**
   * 预定集团订单
   * @description: 预定集团订单
   * @param {Object} data
   * @return:
   */
  static GroupCreateOrder(params, type = "post") {
    return sendRequest(url.GroupOrder_CreateOrder, params, type);
  }
  /**
   * 修改集团订单
   * @description: 修改集团订单
   * @param {Object} data
   * @return:
   */
  static GroupUpdateOrder(params, type = "post") {
    return sendRequest(url.GroupOrder_UpdateOrder, params, type);
  }

  /**
   * 获取集团订单房价
   * @description: 获取集团订单房价
   * @param {Object} data
   * @return:
   */
  static GroupRoomPrice(params, type = "post") {
    return sendRequest(url.GroupOrder_RoomPrice, params, type);
  }
  /**
   * 取消订单(集团版)整单
   */
  static GroupOrderCancel(params, type = "post") {
    return sendRequest(url.GroupOrder_CancelOrder, params, type);
  }

  /**
   * 恢复订单(集团版)整单
   */
  static GroupOrderRecover(params, type = "post") {
    return sendRequest(url.GroupOrder_RecoverOrder, params, type);
  }
  /**
   * 取消订单(集团版) 订单明细
   * @description: 取消订单(集团版) 订单明细
   * @param {Object} data
   * @return:
   */
  static GroupCancelDetail(params, type = "post") {
    return sendRequest(url.GroupOrder_CancelDetail, params, type);
  }

  /**
   * 恢复订单(集团版) 订单明细
   * @description: 恢复订单(集团版) 订单明细
   * @param {Object} data
   * @return:
   */
  static GroupRecoverDetail(params, type = "post") {
    return sendRequest(url.GroupOrder_RecoverDetail, params, type);
  }
}
